module.exports = __webpack_public_path__ + "static/media/pak-shop-pic-R.d22b1155.PNG";